import React from 'react';

import { DashboardContentLayout, LocationTabs } from '@portals/framework';

import { ProductsTable } from './ProductsTable';

export function ProductsCatalogPage() {
  return (
    <DashboardContentLayout pageTitle="Product Catalog" bg="gray.0">
      <LocationTabs
        tabs={[
          {
            id: 'active',
            name: 'active',
            title: 'Active Products',
            Component: () => <ProductsTable archivedOnly={false} />,
          },
          {
            id: 'archived',
            name: 'archived',
            title: 'Archived Products',
            Component: () => <ProductsTable archivedOnly />,
          },
        ]}
      />
    </DashboardContentLayout>
  );
}
